module.exports = __webpack_public_path__ + "static/media/cart.dd260ec0.svg";